import { combine, withEffect, withMemo } from 'react-hooks-combine'

import SlotHostComponent from './component'
import { SlotHostController } from './host.controller'

export const SlotHost = combine(
  withMemo(
    'hostController',
    () => {
      return new SlotHostController()
    },
    []
  ),

  withEffect(({ hostController }) => {
    return () => hostController.dispose()
  }, [])
)(SlotHostComponent)
